import { useState, useCallback } from "react";
import type { ManualFlight } from "../types/manual-flight.types";

export function useFlightSelection(flights: ManualFlight[]) {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const toggleOne = useCallback((id: string) => {
    setSelectedIds((prev) => {
      const next = new Set<string>(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  }, []);

  const toggleAll = useCallback(() => {
    setSelectedIds((prev) =>
      prev.size === flights.length
        ? new Set<string>()
        : new Set<string>(flights.map((f) => String(f.id)))
    );
  }, [flights]);
  

  const clearSelection = useCallback(() => setSelectedIds(new Set()), []);

  const allSelected = flights.length > 0 && selectedIds.size === flights.length;
  const someSelected = selectedIds.size > 0 && !allSelected;

  return { selectedIds, toggleOne, toggleAll, clearSelection, allSelected, someSelected };
}
